/**
 * Resolução locale → conteúdo, por PROJEÇÃO das áreas.
 *
 * Não existe um `pt-BR.ts`/`en-US.ts` compondo o objeto inteiro por idioma: há UMA composição,
 * locale-agnóstica, que lê cada área pelo locale pedido. A consequência que vale mais que a
 * economia de linhas é que **divergência de chaves entre idiomas fica impossível por
 * construção** — se uma área não tem o locale, o `Bilingual` dela não compila.
 *
 * Acrescentar área é uma linha aqui e um arquivo em `sections/`.
 */
import type { AdminLocale } from './locale.js';
import { SHELL_CONTENT, type ShellContent } from './sections/shell.js';

export interface AdminContent {
  readonly shell: ShellContent;
}

export function getAdminContent(locale: AdminLocale): AdminContent {
  return {
    shell: SHELL_CONTENT[locale],
  };
}
